import * as React from "react"

import { cn } from "./cn"

/**
 * A native select, in the look of the text field. Native on purpose: the
 * browser's own list works with the keyboard, on a phone and with a screen
 * reader. In the AVEX design the arrow and the outline come from the
 * stylesheet, which shapes every select alike.
 */
function Select({
  className,
  compact = false,
  ...props
}: React.ComponentProps<"select"> & {
  /** The row height of a table or a toolbar, as on `Input`. */
  compact?: boolean
}) {
  return (
    <select
      data-slot="select"
      className={cn(
        "h-10 rounded-xl border border-gray-200 bg-gray-50 px-3 text-sm text-gray-900 outline-none transition-all focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 disabled:cursor-not-allowed disabled:opacity-50",
        compact && "h-9 px-2 avex:h-8",
        className
      )}
      {...props}
    />
  )
}

/** A multi-line text field, in the look of the text field. */
function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "min-h-20 w-full rounded-xl border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-900 outline-none transition-all focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Select, Textarea }
